<div class="layer_details__subtitle">Dimensions:</div>
<app-layer-details-length-row
  [left]="true"
  label="Length:"
  [value]="(layer | angleIronDimensions)?.length"
  [unitsSystem]="unitsSystem"
></app-layer-details-length-row>
<app-layer-details-length-row
  [left]="true"
  label="Leg 1:"
  [value]="(layer | angleIronDimensions)?.leg1"
  [unitsSystem]="unitsSystem"
></app-layer-details-length-row>
<app-layer-details-length-row
  [left]="true"
  label="Leg 2:"
  [value]="(layer | angleIronDimensions)?.thickness"
  [unitsSystem]="unitsSystem"
></app-layer-details-length-row>
<app-layer-details-thickness-field
  [layer]="layer"
  [value]="(layer | angleIronDimensions)?.thickness"
  [unitsSystem]="unitsSystem"
  class="layer_details__row left"
></app-layer-details-thickness-field>
<app-layer-details-copy-button (copyClicked)="copyDimensions()"></app-layer-details-copy-button>
<app-layer-details-position [position]="layer | angleIronCenter"> </app-layer-details-position>
<app-layer-details-geolocation [position]="layer | angleIronCenter"></app-layer-details-geolocation>
